(() => {
  const source = document.querySelector('[data-fw26-index-experience-source]');
  const root = document.querySelector('[data-fw26-men]');
  const index = root?.querySelector('[data-fw26-index]');
  if (!source || !root || !index || source.dataset.mounted === 'true') return;
  source.dataset.mounted = 'true';

  const mobileQuery = window.matchMedia('(max-width: 699px)');
  const cards = [...index.querySelectorAll('[data-fabric-card]')];
  const sourceFitButtons = [...index.querySelectorAll('[data-fit]')];
  const templates = new Map(
    [...source.querySelectorAll('[data-fw26-detail-template]')].map((template) => [
      template.dataset.handle,
      template
    ])
  );

  const storageKey = `fw26-index:${location.pathname}`;
  const minimumInput = index.querySelector('[data-weight-min]');
  const maximumInput = index.querySelector('[data-weight-max]');
  const absoluteMinimum = Number(minimumInput?.min || 5);
  const absoluteMaximum = Number(maximumInput?.max || 24);
  const step = Number(minimumInput?.step || 0.25);
  const defaultState = {
    garment: 'all',
    fits: [],
    minimum: absoluteMinimum,
    maximum: absoluteMaximum
  };

  const readStorage = () => {
    try {
      return JSON.parse(sessionStorage.getItem(storageKey) || '{}');
    } catch (_) {
      return {};
    }
  };

  const cloneState = (state) => ({
    garment: state?.garment || 'all',
    fits: Array.isArray(state?.fits) ? [...state.fits] : [],
    minimum: Number.isFinite(Number(state?.minimum)) ? Number(state.minimum) : absoluteMinimum,
    maximum: Number.isFinite(Number(state?.maximum)) ? Number(state.maximum) : absoluteMaximum
  });

  let appliedState = cloneState({ ...defaultState, ...(readStorage().filters || {}) });
  let pendingState = cloneState(appliedState);
  let previousFocus = null;

  const discovery = document.querySelector('[data-fw26-discovery]');
  const chips = document.querySelector('[data-fw26-chips]');
  const grid = index.querySelector('[data-fabric-grid]');
  if (!discovery || !chips || !grid) return;
  grid.before(discovery, chips);
  discovery.hidden = false;

  const filterOverlay = document.querySelector('[data-fw26-filter-overlay]');
  const detailOverlay = document.querySelector('[data-fw26-detail-overlay]');
  const detailBody = detailOverlay.querySelector('[data-fw26-detail-body]');
  const mobileApply = filterOverlay.querySelector('[data-fw26-mobile-apply]');
  const discoveryCount = discovery.querySelector('[data-fw26-discovery-count]');

  const mobileGarments = filterOverlay.querySelector('[data-fw26-mobile-garments]');
  const mobileFitsBox = filterOverlay.querySelector('[data-fw26-mobile-fits]');
  const mobileMin = filterOverlay.querySelector('[data-fw26-mobile-min]');
  const mobileMax = filterOverlay.querySelector('[data-fw26-mobile-max]');
  const mobileWeightOutput = filterOverlay.querySelector('[data-fw26-mobile-weight-output]');

  mobileFitsBox.replaceChildren(...sourceFitButtons.map((button) => {
    const clone = button.cloneNode(true);
    clone.classList.remove('is-active');
    clone.setAttribute('aria-pressed', 'false');
    return clone;
  }));

  const formatWeight = (value) => {
    const number = Number(value);
    return `${Number.isInteger(number) ? number : Number(number.toFixed(2))}oz`;
  };

  const weightFiltered = (state) =>
    state.minimum > absoluteMinimum || state.maximum < absoluteMaximum;

  const cardMatches = (card, state) => {
    const garments = (card.dataset.garments || '').split(/\s+/).filter(Boolean);
    const fits = (card.dataset.fits || '').split(/\s+/).filter(Boolean);
    const weight = Number(card.dataset.weight);
    const garmentMatch = state.garment === 'all' || garments.includes(state.garment);
    const fitMatch = state.fits.every((fit) => fits.includes(fit));
    const weightMatch = !weightFiltered(state) ||
      (Number.isFinite(weight) && weight >= state.minimum && weight <= state.maximum);
    return garmentMatch && fitMatch && weightMatch;
  };

  const matchingCount = (state) => cards.filter((card) => cardMatches(card, state)).length;

  const writeStorage = (extra = {}) => {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({
        ...readStorage(),
        filters: appliedState,
        ...extra
      }));
    } catch (_) {}
  };

  const renderChips = () => {
    chips.replaceChildren();

    const addChip = (label, remove) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.innerHTML = `<span>${label}</span><span aria-hidden="true">×</span>`;
      button.addEventListener('click', remove);
      chips.append(button);
    };

    if (appliedState.garment !== 'all') {
      const label = appliedState.garment === 'tops'
        ? filterOverlay.dataset.topsLabel
        : filterOverlay.dataset.bottomsLabel;
      addChip(label, () => {
        appliedState.garment = 'all';
        applyMobileFilters();
      });
    }

    appliedState.fits.forEach((fit) => {
      const sourceButton = sourceFitButtons.find((button) => button.dataset.fit === fit);
      addChip(sourceButton?.textContent?.trim() || fit, () => {
        appliedState.fits = appliedState.fits.filter((item) => item !== fit);
        applyMobileFilters();
      });
    });

    if (weightFiltered(appliedState)) {
      addChip(`${formatWeight(appliedState.minimum)} – ${formatWeight(appliedState.maximum)}`, () => {
        appliedState.minimum = absoluteMinimum;
        appliedState.maximum = absoluteMaximum;
        applyMobileFilters();
      });
    }

    chips.hidden = !mobileQuery.matches || chips.childElementCount === 0;
  };

  const applyMobileFilters = ({ notifyCore = true } = {}) => {
    if (!mobileQuery.matches) return;

    let visibleCount = 0;
    cards.forEach((card) => {
      const visible = cardMatches(card, appliedState);
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    renderChips();
    const label = visibleCount === 1 ? 'fabric' : root.dataset.resultsLabel;
    discoveryCount.textContent = `${visibleCount} ${label}`;
    const status = index.querySelector('[data-index-status]');
    if (status) status.textContent = `${visibleCount} ${label}`;
    writeStorage();

    if (notifyCore) {
      root.dispatchEvent(new CustomEvent('fw26:external-filters', {
        detail: cloneState(appliedState)
      }));
    }
  };

  const syncDrawer = () => {
    mobileGarments.querySelectorAll('button').forEach((button) => {
      const active = button.dataset.value === pendingState.garment;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });

    mobileFitsBox.querySelectorAll('[data-fit]').forEach((button) => {
      const active = pendingState.fits.includes(button.dataset.fit);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });

    mobileMin.value = String(pendingState.minimum);
    mobileMax.value = String(pendingState.maximum);
    mobileWeightOutput.textContent = weightFiltered(pendingState)
      ? `${formatWeight(pendingState.minimum)} – ${formatWeight(pendingState.maximum)}`
      : root.dataset.allWeightsLabel;

    const count = matchingCount(pendingState);
    mobileApply.textContent = `${filterOverlay.dataset.showLabel} ${count} ${count === 1 ? 'FABRIC' : 'FABRICS'}`;
  };

  const setOverlay = (overlay, open) => {
    overlay.hidden = !open;
    document.documentElement.classList.toggle(
      'fw26-preview-dialog-open',
      !filterOverlay.hidden || !detailOverlay.hidden
    );
  };

  const openFilters = (sectionName) => {
    previousFocus = document.activeElement;
    pendingState = cloneState(appliedState);
    syncDrawer();
    setOverlay(filterOverlay, true);
    requestAnimationFrame(() => {
      filterOverlay.querySelector(`[data-fw26-filter-section="${sectionName}"]`)?.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      });
      filterOverlay.querySelector('[data-fw26-close-filters]')?.focus();
    });
  };

  discovery.addEventListener('click', (event) => {
    const button = event.target.closest('[data-fw26-open-filter]');
    if (!button) return;
    openFilters(button.dataset.fw26OpenFilter);
  });

  filterOverlay.querySelector('[data-fw26-close-filters]').addEventListener('click', () => {
    setOverlay(filterOverlay, false);
    previousFocus?.focus?.();
  });

  filterOverlay.addEventListener('click', (event) => {
    if (event.target === filterOverlay) setOverlay(filterOverlay, false);
  });

  mobileGarments.addEventListener('click', (event) => {
    const button = event.target.closest('button[data-value]');
    if (!button) return;
    pendingState.garment = button.dataset.value;
    syncDrawer();
  });

  mobileFitsBox.addEventListener('click', (event) => {
    const button = event.target.closest('[data-fit]');
    if (!button) return;
    const fit = button.dataset.fit;
    pendingState.fits = pendingState.fits.includes(fit)
      ? pendingState.fits.filter((item) => item !== fit)
      : [...pendingState.fits, fit];
    syncDrawer();
  });

  const updatePendingWeight = (changed) => {
    if (Number(mobileMin.value) > Number(mobileMax.value) - step) {
      if (changed === 'minimum') mobileMin.value = String(Number(mobileMax.value) - step);
      else mobileMax.value = String(Number(mobileMin.value) + step);
    }
    pendingState.minimum = Number(mobileMin.value);
    pendingState.maximum = Number(mobileMax.value);
    syncDrawer();
  };

  mobileMin.addEventListener('input', () => updatePendingWeight('minimum'));
  mobileMax.addEventListener('input', () => updatePendingWeight('maximum'));

  filterOverlay.querySelector('[data-fw26-mobile-reset]').addEventListener('click', () => {
    pendingState = cloneState(defaultState);
    syncDrawer();
  });

  mobileApply.addEventListener('click', () => {
    appliedState = cloneState(pendingState);
    applyMobileFilters();
    setOverlay(filterOverlay, false);
  });

  const arrangeDetailNotification = () => {
    const detail = detailBody.querySelector('.fw26-preview-detail');
    const notify = detail?.querySelector('.fw26-preview-detail__notify');
    const visual = detail?.querySelector('.fw26-preview-detail__visual');
    const content = detail?.querySelector('.fw26-preview-detail__content');
    const discoverLink = content?.querySelector('.fw26-preview-detail__link');
    if (!notify || !visual || !content) return;

    if (mobileQuery.matches) {
      notify.open = false;
      content.insertBefore(notify, discoverLink || null);
    } else {
      notify.open = true;
      visual.append(notify);
    }
  };

  const openDetail = (handle) => {
    const template = templates.get(handle);
    if (!template) return;
    previousFocus = document.activeElement;
    detailBody.replaceChildren(template.content.cloneNode(true));
    arrangeDetailNotification();
    const title = detailBody.querySelector('h2');
    if (title) title.id = detailOverlay.querySelector('[aria-labelledby]')?.getAttribute('aria-labelledby') || 'fw26-preview-detail-title';
    setOverlay(detailOverlay, true);
    writeStorage({ openHandle: handle });
    detailOverlay.querySelector('[data-fw26-close-detail]')?.focus();
  };

  const closeDetail = () => {
    setOverlay(detailOverlay, false);
    writeStorage({ openHandle: null });
    previousFocus?.focus?.();
  };

  detailOverlay.querySelector('[data-fw26-close-detail]').addEventListener('click', closeDetail);
  detailOverlay.addEventListener('click', (event) => {
    if (event.target === detailOverlay) closeDetail();
  });

  index.addEventListener('click', (event) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('.fw26-men-fabric-card__media, .fw26-men-fabric-card h3 a');
    if (!link) return;
    const card = link.closest('[data-fabric-card]');
    if (!card?.dataset.handle) return;
    event.preventDefault();
    openDetail(card.dataset.handle);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (!detailOverlay.hidden) closeDetail();
    else if (!filterOverlay.hidden) {
      setOverlay(filterOverlay, false);
      previousFocus?.focus?.();
    }
  });

  root.addEventListener('fw26:filters-state', (event) => {
    appliedState = cloneState(event.detail || defaultState);
    if (mobileQuery.matches) applyMobileFilters({ notifyCore: false });
  });

  mobileQuery.addEventListener?.('change', (event) => {
    arrangeDetailNotification();
    appliedState = cloneState({ ...defaultState, ...(readStorage().filters || {}) });
    if (event.matches) {
      applyMobileFilters({ notifyCore: false });
    } else {
      chips.hidden = true;
      cards.forEach((card) => { card.hidden = false; });
      root.dispatchEvent(new CustomEvent('fw26:external-filters', {
        detail: cloneState(appliedState)
      }));
      if (!filterOverlay.hidden) setOverlay(filterOverlay, false);
    }
  });

  window.addEventListener('pagehide', () => {
    writeStorage({
      scrollY: window.scrollY,
      openHandle: detailOverlay.hidden ? null : readStorage().openHandle
    });
  });

  const navigationEntry = performance.getEntriesByType?.('navigation')?.[0];
  if (navigationEntry?.type === 'back_forward') {
    requestAnimationFrame(() => requestAnimationFrame(() => {
      const restored = readStorage();
      if (Number.isFinite(restored.scrollY)) window.scrollTo(0, restored.scrollY);
      if (restored.openHandle) openDetail(restored.openHandle);
    }));
  }

  if (mobileQuery.matches) applyMobileFilters({ notifyCore: false });
  else discoveryCount.textContent = `${cards.length} ${root.dataset.resultsLabel}`;
})();
